var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSchoolIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5C10.5418 5.00172 9.1439 5.58174 8.11282 6.61281C7.08174 7.64389 6.50173 9.04184 6.50001 10.5C6.49826 11.6916 6.8875 12.8509 7.60801 13.8C7.60801 13.8 7.75801 13.9975 7.78251 14.026L12 19L16.2195 14.0235C16.2415 13.997 16.392 13.8 16.392 13.8L16.3925 13.7985C17.1127 12.8498 17.5017 11.6911 17.5 10.5C17.4983 9.04184 16.9183 7.64389 15.8872 6.61281C14.8561 5.58174 13.4582 5.00172 12 5ZM12.5 13H11.5V12H12.5V13ZM12.5 11H11.5V10H12.5V11ZM14.5 13H13.5V9H10.5V13H9.50001V9C9.50027 8.73486 9.60571 8.48066 9.79319 8.29319C9.98067 8.10571 10.2349 8.00026 10.5 8H13.5C13.7651 8.00026 14.0193 8.10571 14.2068 8.29319C14.3943 8.48066 14.4997 8.73486 14.5 9V13Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolIcon);
export default __webpack_public_path__ + "static/media/school_icon.ac8e92cd5d0552c7375a7d19040d2f9c.svg";
export { ForwardRef as ReactComponent };